<template>
  <div class="price-wrapper--custom" :class="{ 'is-drawer': isDrawer }">
    <!-- eslint-disable -->
    <LadPriceMSI :product="{ is_lad: isLad }" />
    <!-- eslint-enable -->

    <div v-if="_hasDiscount" class="price-with-promotions">
      <div v-if="showPerPerson || hasDateRestriction" class="container-before">
        {{ $t(`${base}.before`) }}
        <span class="price-before">{{ `${symbol}${withoutDiscount}` }}</span>
      </div>

      <div class="container-you-save">
        {{ $t(`${base}.you_save`) }}
        <span class="price-you-save">{{
          `${symbol}${youSaveWithFormat}`
        }}</span>
      </div>
    </div>

    <p
      class="full-price"
      :class="{ 'full-price-with-promotions': _hasDiscount }"
    >
      <span class="symbol">{{ symbol }}</span>
      <span class="price">{{ amount }}</span>
      <span class="container-decimal-currency">
        <span class="decimal">{{ `${decimal}${cents}` }}</span>
        <span class="currency">{{ `${currency}` }}</span>
      </span>
    </p>

    <p
      v-if="showPerPerson || hasDateRestriction"
      class="total-price-per-person"
      >{{ $t(`${base}.total_price_per_person`) }}</p
    >
    <p v-else class="total-price-per-person">{{
      $t(`${base}.total_price_per_person_${promoType}`)
    }}</p>

    <p class="reserve-with"
      >{{ $t(`${base}.reserve_with`) }}
      <span class="reserve-with--price">{{ reserveWith }}</span>
      <el-tag
        v-if="showMSI"
        type="success"
        effect="plain"
        size="mini"
        class="reserve-with--msi"
      >
        {{ $t(`${base}.msi`) }}
      </el-tag>
    </p>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import LadPricePromoMixin from '@/components/frontends/Price/components/mixin/promo'
import LadPriceMSI from '@/components/frontends/Price/components/msi'

export default {
  name: 'LadPriceExperienceCustom',
  components: { LadPriceMSI },
  mixins: [LadPricePromoMixin],
  props: {
    isDrawer: { type: Boolean, default: false },
    externalPrice: { type: Number, required: false, default: 0 },
  },
  data() {
    return {
      base: 'experience.price',
      symbol: '$',
    }
  },
  computed: {
    ...mapState('experience', {
      promotions: 'promotions',
      isLad: (state) => state.experience.is_lad,
      totalAmount: (state) => state.sales_plan.total_amount,
      layawayAmount: (state) => state.sales_plan.layaway_amount,
    }),
    ...mapState('settings', {
      currency: (state) => state.currency,
      paymentPlans: (state) => state.payment_plans,
    }),
    /** meses sin intereses */
    showMSI() {
      const k = this.isLad ? 'lad' : 'others'

      return (this.paymentPlans[k] || []).some((t) => t.percent === 0)
    },
    // TODO: this is necessary to section price
    reserveWith() {
      return this.$options.filters.ladFnCurrency(
        this.layawayAmount,
        this.currency
      )
    },
    showPerPerson() {
      return !(
        this.promoType.startsWith('promo_2x1') ||
        this.promoType.startsWith('promo_3x1')
      )
    },
    hasDateRestriction() {
      return this.promoType.endsWith('_dates') && !this.showDiscountOrPromo
    },
    _hasDiscount() {
      return (
        this.hasDiscount || (!this.showPerPerson && !this.hasDateRestriction)
      )
    },
    youSaveWithFormat() {
      let value = 0
      if (this._hasDiscount) {
        switch (true) {
          case this.promoType.startsWith('promo_2x1'):
            value = this.$options.filters.ladFnCurrency(
              this.price,
              this.currency,
              true,
              ''
            )
            break

          case this.promoType.startsWith('promo_3x1'):
            value = this.$options.filters.ladFnCurrency(
              this.price * 2,
              this.currency,
              true,
              ''
            )
            break

          default:
            value = this.discountWithFormat
            break
        }
      }

      return value
    },
    hasPrice() {
      return parseFloat(this.externalPrice || this.totalAmount) > 0
    },
    price() {
      return this.externalPrice || this.totalAmount
    },
    amountCurrency() {
      return this.$options.filters
        .ladFnCurrency(this.price, this.currency, false)
        .subtract(this.discountAmount)
    },
    amountWithoutFormat() {
      return this.amountCurrency.format(false).replace(this.symbol, '')
    },
    amount() {
      return this.showZeroPrice && this.amountCurrency.dollars() === 0
        ? '-'
        : this.amountWithoutFormat.slice(0, -3)
    },
    cents() {
      const length = this.amountWithoutFormat.length

      return this.amount === '-' && this.amountCurrency.cents() === 0
        ? '--'
        : this.amountWithoutFormat.slice(-2, length)
    },
    decimal() {
      return this.amountCurrency.s.decimal
    },
  },
}
</script>

<style lang="scss">
.price-wrapper--custom {
  .wrapper-msi-promotion {
    .discount-value {
      border-radius: 10px;
      border: 1px solid rgba(201, 24, 0, 0.3);
      padding: 3px 5.3px 3px 6px;

      span {
        color: #c91800;
        font-size: 11.2px;
        font-style: normal;
        font-weight: 700;
        line-height: 12.88px; /* 115% */
      }
    }
  }

  .price-with-promotions {
    margin: 10px 0;

    .container-before,
    .container-you-save {
      display: inline-block;
      color: black;
      font-size: 11.2px;
      font-style: normal;
      font-weight: 400;
      line-height: 12.88px; /* 115% */
      text-transform: capitalize;

      .price-before {
        font-size: 14px;
        font-weight: 700;
        text-decoration: line-through;
      }

      .price-you-save {
        color: #1aa31c;
        font-size: 14px;
        font-weight: 500;
      }
    }

    .container-before {
      margin-right: 10px;
    }

    .container-you-save {
      border-radius: 50px;
      border: 1.5px solid rgba(50, 152, 0, 0.3);
      padding: 4px 12px;
    }
  }

  .price-with-promo-type {
    // margin-top: 10px;

    .container-promo-type {
      display: inline-block;
      color: black;
      font-size: 11.2px;
      font-style: normal;
      font-weight: 400;
      line-height: 12.88px; /* 115% */
      text-transform: capitalize;
      border-radius: 50px;
      border: 1px solid rgba(201, 24, 0, 0.3);
      padding: 4px 12px;

      .price-promo-type {
        color: #c91800;
        font-size: 14px;
        font-weight: 500;
      }
    }
  }

  .full-price {
    margin: 15px 0 10px;

    .symbol {
      color: #000;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 16.1px; /* 115% */
      vertical-align: top;
    }

    .price {
      color: #000;
      font-size: 49px;
      font-style: normal;
      font-weight: 700;
      line-height: 35.35px; /* 115% */
    }

    .decimal {
      color: #000;
      font-size: 12.6px;
      font-style: normal;
      font-weight: 400;
      line-height: 14.49px; /* 115% */
      vertical-align: top;
    }

    .currency {
      color: #030303;
      font-size: 10.1px;
      font-style: normal;
      font-weight: 700;
      line-height: 11.59px; /* 114.752% */
      text-transform: uppercase;
    }

    .container-decimal-currency {
      display: inline-flex;
      flex-direction: column;
      vertical-align: top;
      height: 38px;
      place-content: space-between;
    }

    &-with-promotions {
      .price,
      .decimal {
        color: #1aa31c;
      }
    }
  }

  .total-price-per-person {
    margin: 0;
    color: #000;
    font-size: 15.2px;
    font-style: normal;
    font-weight: 700;
    line-height: 12.88px; /* 84.737% */
  }

  .reserve-with {
    display: none;
    color: #000;
    font-size: 15.2px;
    font-style: normal;
    font-weight: 400;
    line-height: 12.88px; /* 84.737% */

    &--price {
      font-weight: 700;
    }

    &--msi {
      border-radius: 50px;
      border: 1.5px solid #1aa31c;
      color: #1aa31c;
      font-size: 11.2px;
      font-weight: 700;
    }
  }

  &.is-drawer {
    .wrapper-msi-promotion,
    .price-with-promotions,
    .total-price-per-person {
      display: none;
    }

    .full-price {
      margin: 0;

      .symbol,
      .price {
        color: #1aa31c;
        font-size: 20px;
        line-height: 12.88px; /* 64.4% */
        font-weight: 700;
        vertical-align: text-top;
      }

      .container-decimal-currency {
        display: unset;
        vertical-align: unset;
        height: unset;
        margin-left: -4px;

        .decimal {
          vertical-align: unset;
          color: #1aa31c;
          font-size: 20px;
          font-style: normal;
          font-weight: 700;
        }
      }
    }

    .reserve-with {
      display: block;
      margin: 0;
    }
  }
}
</style>
